import React, { useState, useEffect } from "react";
import {
  IonGrid,
  IonLabel,
  IonItem,
  IonRadio,
  IonList,
  IonRadioGroup,
  IonListHeader,
  IonRow,
  IonButton,
  IonModal,
  IonInput,
} from "@ionic/react";

import "./OnCallLookUpInput.scss";
import { OnCallLookUpInputService } from "../../OnCalllookUpService";
import DatePickerComponent from "../../../../components/Shared/DatePicker/datepicker-component";
import TimePicker from "../../../../components/Shared/TimePicker/timepicker-component";
import DropDown from "../../../../components/Shared/Dropdown/dropdown-component";
import {
  SiteListResponseModal,
  ResultModal,
  ReturnDataModel,
  NetworkListResponseModal,
  NetworkResultModal,
  NetworkItem,
} from "../../OnCallLookUpModel";
import { utilService } from "../../../../services";
import { CONSTANTS } from "../../../../constants/callcentral.constants";
import { statusBoardService } from "../../../StatusBoard/StatusBoard.service";
import { useContext } from "react";
import { AddProviderContext } from "../../../StatusBoard/components/StatusBoardTable/components/ExpandedCard/components/SBoardProvider/SBoardProvider";
import classNames from "classnames/bind";
import { SupportStaffProviderContext } from "../../../StatusBoard/components/SupportStaff/SupportStaff";
import { onCallSearchResultService } from "../OnCallSearchResult/OnCallSearchResult.service";
import _ from "lodash";
import moment from "moment";
import { useNetwork } from "../../../../helpers/NetworkContext";
import NetworkDropDown from "../../../../components/Shared/Dropdown/networkDropdown-component";
import { loggedInUserService } from "../../../../services/loggedInUser.service";
import { useTranslation } from "react-i18next";

interface ListModal {
  dataId: number;
  dataName: string;
  default?: boolean
}

interface NetworkModal {
  dataId: number;
  dataName: string;
  default?: boolean;
}




interface onCallLookUpInputProps {
  getInputs: (data: ReturnDataModel) => void;
  siteResetClicked: (value: boolean) => void;
  dataFromComponent: string;
  resetSearchBy: boolean;
  siteId: string;
  networkId: any;
  favCardData?: any;
  setSelectedGuid?: any;
}

const OnCallLookUpComponent: React.FC<onCallLookUpInputProps> = (props) => {
  const { selectedNetwork, setSelectedNetwork } = useNetwork(); // ✅ use context here
  const { t } = useTranslation("onCallLookup");
  const AddProviderContextData = useContext(
    statusBoardService.selectedProviderPoupType
      ? SupportStaffProviderContext
      : AddProviderContext
  );

  const [siteList, setSiteList] = useState<ListModal[]>([]);
  const [networkList, setNetworkList] = useState<NetworkModal[]>([]);
  const [selectedSite, setSelectedSite] = useState<any>(0);
  // const [selectedNetwork, setSelectedNetwork] = useState<any>('');
  const [selectedBy, setSelectedBy] = useState<string>("");
  const [selectedDate, setSelectedDate] = useState<any>(
    utilService.getCurrentDate
  );
  const [selectedTime, setSelectedTime] = useState<any>(
    utilService.getFormattedCurrentTime
  );
  const [isSiteSelected, setIsSiteSelectedFlag] = useState<boolean>(true);
  const [timeData, setTimeData] = useState("");
  const [screenType, setScreenType] = useState<string>("");
  const [showDatePickerModal, setDatePickerModal] = useState(false);
  const [showStartTimePickerModal, setStartTimePickerModal] = useState(false);
  const [defaultNetwork, setDefaultNetwork] = useState<{ key: string; value: string } | null>(null);
  const [isN2nPermission, setisN2nPermission] = useState<any>(false);
  
    useEffect(() => {
      const subscription = loggedInUserService.loggedInUserData.subscribe((data: any) => {
        setisN2nPermission(data?.userData?.n2nActivation)
      });
      
      // Module-level Subject: without this, every mount left a live
      // handler behind, so one update was handled once per visit.
      return () => subscription.unsubscribe();
    }, []);

  useEffect(() => {
    IsSiteSelctedOrChanged();
    getScreenTypeString();
    getNetworkList();
  }, []);

  const getScreenTypeString = () => {
    setScreenType(utilService.getScreenSize());
  };

  useEffect(() => {
    if (props.siteId) {
      setSelectedSite(props.siteId);
    }
  }, [props.siteId]);

  const getSelectedItem = (key: any, value: any, defaultVal?: boolean) => {
  setSelectedNetwork({ key, value, default: defaultVal });
};

useEffect(() => {
  if (_.isEmpty(networkList)) return;

  const favParams = props?.favCardData?.params;
  let networkData;

  if (favParams?.network_id && favParams?.network) {
    networkData = {
      key: Number(favParams.network_id),
      value: String(favParams.network),
      default: true,
    };
  } else {
    const defaultNetwork = networkList.find((item) => item.default === true);
    if (defaultNetwork) {
      networkData = {
        key: defaultNetwork.dataId,
        value: defaultNetwork.dataName,
        default: defaultNetwork.default,
      };
    }
  }

  if (networkData) {
    setSelectedNetwork(networkData);
    getSelectedItem(networkData.value, networkData.key, networkData.default);
  }
}, [networkList, props.favCardData]);
 
  // useEffect(() => {
  //   if (props.networkId) {
  //     setSelectedNetwork(props.networkId);
  //   }
  // }, [props.networkId]);

  // useEffect(() => {

  //   const defaultNetworkVal = networkList?.find((item) => item.default === true);
  //   if (defaultNetworkVal) {
  //     setSelectedNetwork({ key: defaultNetworkVal.dataId, value: defaultNetworkVal.dataName, default: defaultNetworkVal.default });
  //   }
  // }, [networkList]);


  useEffect(() => {
    getSiteList();
  }, [selectedNetwork])



  useEffect(() => {
    if (AddProviderContextData.fromComponent === "") {
      // getSiteList();
      getNetworkList();
    } else {
      setSelectedDate(utilService.getCurrentDate);
      setSelectedTime(utilService.getCurrentTime);
      setSelectedSite(props.siteId);
      // setSelectedNetwork(props.networkId);
      if (
        AddProviderContextData.popUptype ===
        CONSTANTS.PROVIDER_POPUPTYPE.PRIMARY_MD
      ) {
        setSelectedBy("individual_provider");
      } else if (
        AddProviderContextData.popUptype ===
        CONSTANTS.PROVIDER_POPUPTYPE.PROVIDER
      ) {
        setSelectedBy("speciality");
      }
    }
  }, [props.dataFromComponent, props.siteId]);

  useEffect(() => {
    if (!_.isEmpty(props.favCardData)) {
      setTimeFormat();
      setSelectedSite(Number(props.favCardData.params.hospital_id));
      // setSelectedNetwork({ key: props.favCardData.params?.network_id, value: props.favCardData.params?.network,default:false })
      setSelectedByData();
    }
    console.log("reached",props.favCardData)
  }, [props.favCardData]);

  useEffect(() => {
    IsSiteSelctedOrChanged();
  }, [selectedBy]);

  useEffect(() => {
    IsSiteSelctedOrChanged();
  }, [selectedTime]);

  useEffect(() => {
    IsSiteSelctedOrChanged();
  }, [selectedDate]);

  useEffect(() => {
    IsSiteSelctedOrChanged();
    // checkIfCalledFromFavCard();
  }, [selectedNetwork]);

  useEffect(() => {
    checkSiteIsSelected();
    // checkIfCalledFromFavCard();
  }, [selectedSite]);

  useEffect(() => {
    if (props.resetSearchBy) {
      let resetSearchBy = true;
      if (!_.isEmpty(props.favCardData) && screenType === "small") {
        if (!_.isEmpty(props.favCardData.params.nameParams.dr)) {
          if (selectedBy === "individual_provider") {
            resetSearchBy = false;
          }
        } else if (!_.isEmpty(props.favCardData.params.nameParams.group)) {
          if (selectedBy === "group") {
            resetSearchBy = false;
          }
        } else if (!_.isEmpty(props.favCardData.params.nameParams.speciality)) {
          if (selectedBy === "speciality") {
            resetSearchBy = false;
          }
        }
      }
      // if fav card data is binded then no need for resetting search by in mobile devices
      if (resetSearchBy) {
        setSelectedBy("");
      }
    }
  }, [props.resetSearchBy]);

  useEffect(() => {
  if (!_.isEmpty(networkList)) {
    const favParams = props?.favCardData?.params;

    // If favCardData is present, use that
    if (favParams?.network_id && favParams?.network) {
      console.log("Setting from favCardData");
      setSelectedNetwork({
        key: favParams.network_id,
        value: favParams.network,
        default: true,
      });
    } else {
      // Otherwise, fallback to default from networkList
      const defaultNetworkVal = networkList?.find((item) => item.default === true);
      if (defaultNetworkVal) {
        setSelectedNetwork({
          key: defaultNetworkVal.dataId,
          value: defaultNetworkVal.dataName,
          default: true,
        });
      }
    }
  }
}, [networkList, props.favCardData]);

  const checkIfCalledFromFavCard = () => {
    if (
      !_.isEmpty(props.favCardData) &&
      AddProviderContextData.fromComponent === ""
    ) {
      const hospitalId = Number(props.favCardData.params.hospital_id);
      if (
        !_.isEmpty(props.favCardData.params.nameParams.dr) &&
        selectedSite !== hospitalId
      ) {
        props.siteResetClicked(true);
        setSelectedBy("");
      } else if (
        !_.isEmpty(props.favCardData.params.nameParams.group) &&
        selectedSite !== hospitalId
      ) {
        props.siteResetClicked(true);
        setSelectedBy("");
      } else if (
        !_.isEmpty(props.favCardData.params.nameParams.speciality) &&
        selectedSite !== hospitalId
      ) {
        props.siteResetClicked(true);
        setSelectedBy("");
      }
    } else {
      if (AddProviderContextData.fromComponent === "") {
        setSelectedBy("");
      }
      props.siteResetClicked(true);
    }
  };

  const setTimeFormat = () => {
    let hour = props.favCardData.params.hours;
    let minute = props.favCardData.params.minutes;
    let timeData = hour.toString() + ":" + minute.toString();
    setTimeData(timeData);
  };

  const IsSiteSelctedOrChanged = () => {
    if (
      selectedBy === "group" ||
      selectedBy === "speciality" ||
      selectedBy === "individual_provider"
    ) {
      props.getInputs(getDataForReturn());
    }
  };

  const checkSiteIsSelected = () => {
    if (selectedSite > 0) {
      setIsSiteSelectedFlag(false);
    }
  };

  const getDataForReturn = () => {
    const data: ReturnDataModel = {
      DateSelected: selectedDate,
      TimeSelected: moment(selectedTime, "hh:mm A").format("HH:mm"),
      SiteSelected: selectedSite ? selectedSite : props.siteId,
      OptionSelected: selectedBy,
    };
    return data;
  };

  const getSiteList = async () => {
    const apiResponse: SiteListResponseModal =
      await OnCallLookUpInputService.getOnCallLookUpSitesList({
        reg_code: utilService.getNetwork(), n2nNetworkCode: selectedNetwork?.value ?? ''
      });
    if (apiResponse.isSuccess) {
      const siteList_res: ListModal[] = bindData(apiResponse.siteData!);
      const count = apiResponse
        ? apiResponse!.siteData
          ? apiResponse!.siteData!.totalCount
          : []
        : [];
      setSiteList(siteList_res);
      onCallSearchResultService.setonCallSiteListFromComponent(siteList_res);
    }
  };


  const getNetworkList = async () => {
    const apiResponse: NetworkListResponseModal = await OnCallLookUpInputService.getOnCallLookUpNetworksList({
      reg_code: utilService.getNetwork(),
    });

    if (apiResponse.isSuccess) {
      const networkList_res: ListModal[] = bindNetworkData(apiResponse.networkData!);
      console.log(networkList_res, "networkList_res");
      setNetworkList(networkList_res);
      onCallSearchResultService.setonCallSiteListFromComponent(networkList_res);
    }
  };

  const bindNetworkData = (responseData: NetworkResultModal): ListModal[] => {
    const dataArr = responseData.data || [];
    return dataArr.map((item) => ({
      dataId: item.id,
      dataName: item.network, // correct key
      default: item.default ?? false
    }));
  };

  const bindData = (responseData: ResultModal) => {
    const dataArr = responseData.data;
    var result: ListModal[] = dataArr.map((item) => ({
      dataId: (item as any).id,
      dataName: (item as any).name,
    }));
    return result;
  };

  const setSelectedByData = () => {
    if (!_.isEmpty(props.favCardData.params.nameParams.dr)) {
      setSelectedBy("individual_provider");
    } else if (!_.isEmpty(props.favCardData.params.nameParams.group)) {
      setSelectedBy("group");
    } else if (!_.isEmpty(props.favCardData.params.nameParams.speciality)) {
      setSelectedBy("speciality");
    }
    setIsSiteSelectedFlag(true);
  };

  return (
    <div className="ocl-input-wrapper">
      <IonModal
        isOpen={showDatePickerModal}
        className="time-picker-modal"
        backdropDismiss={false}
      >
        <DatePickerComponent
          dateFromParent={utilService.getCurrentDate()}
          getSelectedDate={(value: string) => {
            setSelectedDate(value);
          }}
        ></DatePickerComponent>
        <div className="reminder-button-container">
          <div className="send-button-div">
            <IonButton
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                setDatePickerModal(false);
              }}
            >
              {t("add")}
            </IonButton>
          </div>
        </div>
      </IonModal>
      <IonModal
        isOpen={showStartTimePickerModal}
        className="time-picker-modal"
        backdropDismiss={false}
      >
        <TimePicker
          favCardData={props.favCardData}
          getSelectedTime={(value: string) => {
            let formattedTime = moment(value, "HH:mm").format("hh:mm A");
            setSelectedTime(formattedTime);
          }}
          timeValue={timeData}
        ></TimePicker>
        <div className="reminder-button-container">
          <div className="send-button-div">
            <IonButton
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                setStartTimePickerModal(false);
              }}
            >
              {t("add")}
            </IonButton>
          </div>
        </div>
      </IonModal>
      {AddProviderContextData.fromComponent === "" && (
        <div className="ocl-text-title">
          {AddProviderContextData.fromComponent === "" && (
           <span>{t("onCallLookup")}</span>
          )}
        </div>
      )}
      <div
        className={classNames({
          "ocl-items": true,
          "sb-no-border":
            AddProviderContextData.fromComponent !== "" ? true : false,
        })}
      >
        <IonGrid>
          {AddProviderContextData.fromComponent === "" && (
            <div
              className={classNames({
                "ocl-item": true,
                "ocl-item-padding-full": screenType === "small" ? true : false,
                "ocl-item-padding": screenType !== "small" ? true : false,
              })}
            >
              <IonItem lines="none" class="no-padding">
             <IonLabel>{t("date")}</IonLabel>
              </IonItem>

              <div className="date-picker-container">
                <IonInput
                  id="inputSec"
                  name="display"
                  className=" emt-sac-input"
                  value={utilService.getDayLongFormat(selectedDate)}
                  onClick={() => setDatePickerModal(true)}
                  readonly
                ></IonInput>
              </div>
            </div>
          )}
          {AddProviderContextData.fromComponent === "" && (
            <div
              className={classNames({
                "ocl-item": true,
                "ocl-item-padding-full": screenType === "small" ? true : false,
                "ocl-item-padding": screenType !== "small" ? true : false,
              })}
            >
              <IonItem lines="none">
              <IonLabel>{t("time")}</IonLabel>
              </IonItem>
              <div className="time-picker-container">
                <IonInput
                  id="inputSec"
                  name="display"
                  className=" emt-sac-input"
                  value={selectedTime}
                  onClick={() => setStartTimePickerModal(true)}
                  readonly
                ></IonInput>
              </div>
            </div>
          )}
{AddProviderContextData.fromComponent === "" && isN2nPermission ?
 <div
            className={classNames({
              "ocl-item": true,
              "ocl-item-padding-full": screenType === "small" ? true : false,
              "ocl-item-padding": screenType !== "small" ? true : false,
            })}
          >
            <IonItem lines="none">
           <IonLabel>
             {t("network")}<span className="ocl-star">*</span>
                </IonLabel>

            </IonItem>

            <div className="site-drpdwn-container">
              <NetworkDropDown
                fromFav={false}
                  dropDownValue={t("selectNetwork")}
                siteListData={networkList}
                getSelectedItem={(value: any, key: any, defaultVal?: boolean) => {
                  props.siteResetClicked(true);
                  setIsSiteSelectedFlag(true);
                  setSelectedSite("")
                  setSelectedBy("");
                  setSelectedNetwork({ key, value, default: defaultVal });
                }}
                favCardData={props.favCardData}
                selectedValue={selectedNetwork}
              ></NetworkDropDown>
            </div>
          </div>:null
}
         


          {AddProviderContextData.fromComponent === "" && (
            <div
              className={classNames({
                "ocl-item": true,
                "ocl-item-padding-full": screenType === "small" ? true : false,
                "ocl-item-padding": screenType !== "small" ? true : false,
                "disabled-container": !selectedNetwork,
              })}
            >
              <IonItem lines="none">
                <IonLabel>
                  {t("site")}<span className="ocl-star">*</span>
                </IonLabel>
              </IonItem>

              <div className="site-drpdwn-container">
                <DropDown
                  siteListData={siteList}
                  getSelectedItem={(value: number) => {
                    setSelectedSite(value);
                    setSelectedBy("");
                    props.siteResetClicked(true);
                  }}
                  favCardData={props.favCardData}
                  componentName={"OCL"}
                  selectedValue={selectedSite}
                ></DropDown>
              </div>
            </div>
          )}

          {AddProviderContextData.fromComponent === "" && (
            <div
              className={classNames({
                "ocl-radio-btn-container": true,
                "ocl-item-padding-full": screenType === "small" ? true : false,
              })}
              key={`ocl-radio-group-${selectedBy}`}
            >
              <IonList lines="none">
                <IonRadioGroup
                  value={selectedBy}
                  onIonChange={(e) => setSelectedBy(e.detail.value)}
                >
                  <IonListHeader>
                    <IonLabel className="ocl-sear-by">
                     {t("searchBy")}<span className="ocl-star"> *</span>
                    </IonLabel>
                  </IonListHeader>
                  <IonItem>
                    <IonLabel>{t("group")}</IonLabel>
                    <IonRadio value="group" disabled={selectedSite ? false : true} />
                  </IonItem>
                  <IonItem>
                    <IonLabel>{t("speciality")}</IonLabel>
                    <IonRadio value="speciality" disabled={selectedSite ? false : true} />
                  </IonItem>
                  <IonItem>
                    <IonLabel>{t("individualProvider")}</IonLabel>
                    <IonRadio
                      value="individual_provider"
                      disabled={selectedSite ? false : true}
                    />
                  </IonItem>
                </IonRadioGroup>
              </IonList>
            </div>
          )}

          {AddProviderContextData.fromComponent !== "" && (
            <div className="sboard-provider-oncalllookup-container">
              <IonGrid className="md hydrated">
                <IonRadioGroup
                  value={selectedBy}
                  onIonChange={(e) => {
                    props?.setSelectedGuid("")
                    setSelectedBy(e.detail.value)
                  }}
                >
                  <IonListHeader lines="none">
                    <IonLabel className="ocl-sear-by">
                      {t("searchBy")}<span className="ocl-star"> *</span>
                    </IonLabel>
                  </IonListHeader>
                  <IonRow className="sb-row-group">
                    <IonItem className="ion-item-group">
                      <IonLabel className="label-group mr-2">{t("group")}</IonLabel>
                      <IonRadio value="group" disabled={isSiteSelected} />
                    </IonItem>
                    <IonItem className="ion-item-speciality">
                      <IonLabel className="mr-2">{t("speciality")}</IonLabel>
                      <IonRadio value="speciality" disabled={isSiteSelected} />
                    </IonItem>
                    <IonItem className="ion-item-indprovider">
                      <IonLabel className="mr-2">{t("individualProvider")}</IonLabel>
                      <IonRadio
                        value="individual_provider"
                        disabled={isSiteSelected}
                      />
                    </IonItem>
                  </IonRow>
                </IonRadioGroup>
              </IonGrid>
            </div>
          )}
        </IonGrid>
      </div>
    </div>
  );
};

export default OnCallLookUpComponent;
